(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6188],{

/***/ 40708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ basic_card; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/_enums/basic-card-variants.enum.ts
var basic_card_variants_enum = __webpack_require__(90017);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./src/utils/_enums/product-categories.enum.ts
var product_categories_enum = __webpack_require__(38204);
// EXTERNAL MODULE: ./src/components/_shared/teaser-card-components/teaser-card-category/teaser-card-category.module.scss
var teaser_card_category_module = __webpack_require__(31050);
var teaser_card_category_module_default = /*#__PURE__*/__webpack_require__.n(teaser_card_category_module);
;// CONCATENATED MODULE: ./src/components/_shared/teaser-card-components/teaser-card-category/teaser-card-category.tsx





var TeaserCardCategory = function(props) {
    var getCategoryIcon = function() {
        switch(props.category){
            case product_categories_enum/* ProductCategories.EBOOK */.p.EBOOK:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: [
                        "far",
                        "book-open"
                    ]
                });
            case product_categories_enum/* ProductCategories.ART */.p.ART:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: [
                        "far",
                        "palette"
                    ]
                });
            case product_categories_enum/* ProductCategories.AUDIO */.p.AUDIO:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: [
                        "far",
                        "headphones"
                    ]
                });
            case product_categories_enum/* ProductCategories.BOOK */.p.BOOK:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: [
                        "far",
                        "book"
                    ]
                });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((teaser_card_category_module_default())["category-image-wrapper"], "\n        ").concat((teaser_card_category_module_default())["category-image-wrapper-".concat(props.category)], "\n        ").concat((teaser_card_category_module_default())["category-image-wrapper-".concat(props.style)]),
        children: getCategoryIcon()
    });
};
/* harmony default export */ var teaser_card_category = (TeaserCardCategory);

// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.es.js
var free_solid_svg_icons_index_es = __webpack_require__(51436);
// EXTERNAL MODULE: ./src/utils/_enums/button-variants.enum.tsx
var button_variants_enum = __webpack_require__(92212);
// EXTERNAL MODULE: ./src/components/_shared/button/button.tsx
var button_button = __webpack_require__(93217);
// EXTERNAL MODULE: ./src/components/_shared/media/media.tsx + 3 modules
var media = __webpack_require__(38925);
// EXTERNAL MODULE: ./src/components/_shared/teaser-card-components/teaser-card-profile-picture/teaser-card-profile-picture.tsx + 1 modules
var teaser_card_profile_picture = __webpack_require__(30815);
// EXTERNAL MODULE: ./src/components/_shared/teaser-card-components/teaser-card-images/teaser-card-images.module.scss
var teaser_card_images_module = __webpack_require__(90234);
var teaser_card_images_module_default = /*#__PURE__*/__webpack_require__.n(teaser_card_images_module);
;// CONCATENATED MODULE: ./src/components/_shared/teaser-card-components/teaser-card-images/teaser-card-images.tsx










var TeaserCardImages = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((teaser_card_images_module_default())["basic-card-image-wrapper"], "\n            ").concat(props.aspectRatio ? (teaser_card_images_module_default())["basic-card-image-wrapper-".concat(props.aspectRatio)] : "", "\n            ").concat(props.variant ? (teaser_card_images_module_default())["".concat(props.variant)] : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(media/* Media */.pU, {
                    src: props.mediaUrl,
                    className: (teaser_card_images_module_default()).image,
                    objectFit: "contain",
                    contentType: props.contentType,
                    redirectUrl: props.redirectUrl,
                    initialLoad: props.initialLoad,
                    posterUrl: props.posterUrl,
                    isTeaser: props.isTeaser,
                    squared: true
                })
            }),
            props.duration && props.variant === basic_card_variants_enum/* BasicCardVariants.PODCAST_TEASER */.I.PODCAST_TEASER && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (teaser_card_images_module_default())["podcast-duration"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                    variant: button_variants_enum/* ButtonVariantsEnum.LEFT_ARROW */.l.LEFT_ARROW,
                    className: (teaser_card_images_module_default())["duration-button"],
                    icon: {
                        element: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_solid_svg_icons_index_es/* faMicrophone */.UOM
                        }),
                        align: "left"
                    },
                    children: props.duration
                })
            }),
            props.profilePictureUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (teaser_card_images_module_default())["profile-picture-wrapper"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser_card_profile_picture/* default */.Z, {
                    initialLoad: props.initialLoad,
                    profilePictureId: props.profilePictureUrl
                })
            }),
            props.label && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (teaser_card_images_module_default())["label-wrapper"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (teaser_card_images_module_default()).label,
                    children: props.label.toUpperCase()
                })
            })
        ]
    });
};
/* harmony default export */ var teaser_card_images = (TeaserCardImages);

// EXTERNAL MODULE: ./src/components/_shared/basic-card/basic-card.module.scss
var basic_card_module = __webpack_require__(70010);
var basic_card_module_default = /*#__PURE__*/__webpack_require__.n(basic_card_module);
;// CONCATENATED MODULE: ./src/components/_shared/basic-card/basic-card.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var BasicCard = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: props === null || props === void 0 ? void 0 : props.id,
        className: "\n            ".concat((basic_card_module_default())["basic-card-wrapper"], "\n            ").concat((basic_card_module_default())["".concat(props.type ? props.type : "")], "\n            ").concat((basic_card_module_default())["".concat(!props.disabled && props.onClick ? "clickable" : "")], "\n            ").concat((basic_card_module_default())["".concat(props.disabled ? "disabled" : "")], "\n            "),
        onClick: !props.disabled ? props.onClick : undefined,
        "data-testid": "basic-card",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((basic_card_module_default())["basic-card-content-container"], "\n                ").concat((basic_card_module_default())[props.selected ? "selected" : ""], "\n                ").concat(props.inverted ? (basic_card_module_default()).inverted : ""),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (basic_card_module_default())["teaser-card-images"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser_card_images, _objectSpread({}, props.media, {
                            variant: props.type,
                            duration: props.duration,
                            redirectUrl: props.redirectUrl
                        })),
                        props.author && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (basic_card_module_default()).author,
                            children: props.author
                        }),
                        props.category && props.type === basic_card_variants_enum/* BasicCardVariants.BASIC_CARD_HORIZONTAL_SMALL */.I.BASIC_CARD_HORIZONTAL_SMALL && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (basic_card_module_default())["teaser-card-category-mobile"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser_card_category, {
                                category: props.category,
                                style: "kinked"
                            })
                        }),
                        props.category && props.type === basic_card_variants_enum/* BasicCardVariants.PODCAST_TEASER */.I.PODCAST_TEASER && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (basic_card_module_default())["podcast-category-wrapper"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser_card_category, {
                                category: props.category,
                                style: "arrow"
                            })
                        })
                    ]
                }),
                props.category && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (basic_card_module_default())["teaser-card-category"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(teaser_card_category, {
                        category: props.category,
                        style: "kinked"
                    })
                }),
                props.children
            ]
        })
    });
};
/* harmony default export */ var basic_card = (BasicCard);


/***/ }),

/***/ 67396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67814);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _api_hooks_useCardText_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14375);
/* harmony import */ var _api_models_instance_status__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23812);
/* harmony import */ var _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92212);
/* harmony import */ var _utils_enums_sales_type__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9943);
/* harmony import */ var _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77872);
/* harmony import */ var _utils_helper_locale_helper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50325);
/* harmony import */ var _utils_helper_time_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28508);
/* harmony import */ var _button_button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93217);
/* harmony import */ var _link_link__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(46164);
/* harmony import */ var _link_link_base_link_base__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(27397);
/* harmony import */ var _typography_typography__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(28773);
/* harmony import */ var _teaser_card_footer_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(61979);
/* harmony import */ var _teaser_card_footer_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_teaser_card_footer_module_scss__WEBPACK_IMPORTED_MODULE_14__);















var TeaserCardFooter = function(props) {
    var data = (0,_api_hooks_useCardText_hook__WEBPACK_IMPORTED_MODULE_3__/* .useCardText */ .G)();
    var _redirectUrl, _redirectUrl1, _redirectUrl2, _redirectUrl3;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_teaser_card_footer_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["footer-wrapper"]), " ").concat((_teaser_card_footer_module_scss__WEBPACK_IMPORTED_MODULE_14___default())["".concat(props.type ? props.type : "")]),
        children: [
            props.additionalInfo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_teaser_card_footer_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["additional-info-wrapper"]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_13__/* .Typography */ .Z, {
                    disableMarkdown: true,
                    variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_7__/* .TypographyVariantsEnum.TOPLINE_OR_LABEL */ .H.TOPLINE_OR_LABEL,
                    children: props.additionalInfo
                })
            }),
            props.purchasable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat((_teaser_card_footer_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["buy-wrapper"]), "\n                ").concat(props.salesType === _utils_enums_sales_type__WEBPACK_IMPORTED_MODULE_6__/* .SalesType.FIXED_PRICE */ .r.FIXED_PRICE ? "buy-wrapper-fixed-price" : (_teaser_card_footer_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["buy-wrapper-auction"])),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_teaser_card_footer_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["price-wrapper"]),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: props.purchasable.ownerId && props.salesType === _utils_enums_sales_type__WEBPACK_IMPORTED_MODULE_6__/* .SalesType.FIXED_PRICE */ .r.FIXED_PRICE ? (_teaser_card_footer_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["secondary-price"]) : (_teaser_card_footer_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["primary-price"]),
                                children: props.purchasable.price !== undefined ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_13__/* .Typography */ .Z, {
                                    disableMarkdown: true,
                                    className: "".concat((_teaser_card_footer_module_scss__WEBPACK_IMPORTED_MODULE_14___default().price), " ").concat(props.inverted ? (_teaser_card_footer_module_scss__WEBPACK_IMPORTED_MODULE_14___default().inverted) : ""),
                                    variant: props.purchasable.ownerId && props.salesType === _utils_enums_sales_type__WEBPACK_IMPORTED_MODULE_6__/* .SalesType.FIXED_PRICE */ .r.FIXED_PRICE ? _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_7__/* .TypographyVariantsEnum.TOPLINE_OR_LABEL */ .H.TOPLINE_OR_LABEL : _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_7__/* .TypographyVariantsEnum.HEADING6 */ .H.HEADING6,
                                    children: "".concat((0,_utils_helper_locale_helper__WEBPACK_IMPORTED_MODULE_8__/* .getLocalePrice */ .yb)(props.purchasable.price), "\u20AC")
                                }) : undefined
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: props.purchasable.ownerId && props.salesType === _utils_enums_sales_type__WEBPACK_IMPORTED_MODULE_6__/* .SalesType.FIXED_PRICE */ .r.FIXED_PRICE ? (_teaser_card_footer_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["primary-price"]) : (_teaser_card_footer_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["secondary-price"]),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography_typography__WEBPACK_IMPORTED_MODULE_13__/* .Typography */ .Z, {
                                    disableMarkdown: true,
                                    className: "".concat((_teaser_card_footer_module_scss__WEBPACK_IMPORTED_MODULE_14___default().price), " ").concat(props.inverted ? (_teaser_card_footer_module_scss__WEBPACK_IMPORTED_MODULE_14___default().inverted) : ""),
                                    variant: _utils_enums_typeography_variants_enum__WEBPACK_IMPORTED_MODULE_7__/* .TypographyVariantsEnum.HEADING6 */ .H.HEADING6,
                                    children: (0,_utils_helper_locale_helper__WEBPACK_IMPORTED_MODULE_8__/* .getLocaleEthPrice */ .af)(props.purchasable.ethPrice) + "\u039E"
                                })
                            })
                        ]
                    }),
                    props.purchasable.onBuy ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .z, {
                        onClick: props.purchasable.onBuy,
                        disabled: props.purchasable.status !== _api_models_instance_status__WEBPACK_IMPORTED_MODULE_4__/* .InstanceStatus.OPEN */ .O.OPEN || props.purchasable.buyButtonDisabled,
                        pending: props.purchasable.buyButtonPending,
                        variant: _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .ButtonVariantsEnum.PRIMARY */ .l.PRIMARY,
                        inverted: props.inverted,
                        icon: {
                            element: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                                icon: [
                                    "far",
                                    "cart-plus"
                                ]
                            }),
                            align: "right"
                        },
                        children: props.purchasable.buttonText
                    }) : undefined,
                    props.purchasable.onBid ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .z, {
                        onClick: props.purchasable.onBid,
                        variant: _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .ButtonVariantsEnum.PRIMARY */ .l.PRIMARY,
                        children: data === null || data === void 0 ? void 0 : data.bid
                    }) : undefined
                ]
            }),
            props.onMoreInfoAndBuy && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_link_link_base_link_base__WEBPACK_IMPORTED_MODULE_12__/* .LinkBase */ .w, {
                href: (_redirectUrl = props.redirectUrl) !== null && _redirectUrl !== void 0 ? _redirectUrl : "",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_teaser_card_footer_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["info-and-buy-button-wrapper"]),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .z, {
                        inverted: props.inverted,
                        variant: _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .ButtonVariantsEnum.SECONDARY_OUTLINED */ .l.SECONDARY_OUTLINED,
                        onClick: props.onMoreInfoAndBuy,
                        children: data === null || data === void 0 ? void 0 : data.informAndBuy
                    })
                })
            }),
            props.salesFutureDate && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat((_teaser_card_footer_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["sales-future-date"]), " ").concat(props.inverted ? (_teaser_card_footer_module_scss__WEBPACK_IMPORTED_MODULE_14___default().inverted) : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                            icon: [
                                "far",
                                "clock"
                            ]
                        })
                    }),
                    props.salesFutureDate
                ]
            }),
            props.onInformation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_link_link_base_link_base__WEBPACK_IMPORTED_MODULE_12__/* .LinkBase */ .w, {
                href: (_redirectUrl1 = props.redirectUrl) !== null && _redirectUrl1 !== void 0 ? _redirectUrl1 : "",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_teaser_card_footer_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["info-and-buy-button-wrapper"]),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .z, {
                        variant: _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .ButtonVariantsEnum.SECONDARY_OUTLINED */ .l.SECONDARY_OUTLINED,
                        inverted: props.inverted,
                        onClick: props.onInformation,
                        children: data === null || data === void 0 ? void 0 : data.inform
                    })
                })
            }),
            props.onDetailsAndActions && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_link_link_base_link_base__WEBPACK_IMPORTED_MODULE_12__/* .LinkBase */ .w, {
                href: (_redirectUrl2 = props.redirectUrl) !== null && _redirectUrl2 !== void 0 ? _redirectUrl2 : "",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_teaser_card_footer_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["details-and-auction-button-wrapper"]),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button_button__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .z, {
                        variant: _utils_enums_button_variants_enum__WEBPACK_IMPORTED_MODULE_5__/* .ButtonVariantsEnum.SECONDARY_OUTLINED */ .l.SECONDARY_OUTLINED,
                        onClick: props.onDetailsAndActions,
                        children: data === null || data === void 0 ? void 0 : data.detailsAndActions
                    })
                })
            }),
            props.onMoreInfo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_teaser_card_footer_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["more-info-wrapper"]),
                children: [
                    props.date && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_teaser_card_footer_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["date-wrapper"]),
                        children: (0,_utils_helper_time_helper__WEBPACK_IMPORTED_MODULE_9__/* .formatDate */ .p6)(props.date)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_link_link__WEBPACK_IMPORTED_MODULE_11__/* .Link */ .r, {
                        onClick: props.onMoreInfo,
                        href: (_redirectUrl3 = props.redirectUrl) !== null && _redirectUrl3 !== void 0 ? _redirectUrl3 : "",
                        external: props.isURLExternal,
                        children: props.moreInfoLinkText ? props.moreInfoLinkText : ""
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TeaserCardFooter);


/***/ }),

/***/ 30815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ teaser_card_profile_picture; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
;// CONCATENATED MODULE: ./src/utils/_helper/build-profile-picture-url.tsx

var buildProfilePictureUrl = function(imageId) {
    var publicRuntimeConfig = (0,config["default"])().publicRuntimeConfig;
    return "".concat(publicRuntimeConfig.backendURL, "api/user-profile/image/").concat(imageId);
};

// EXTERNAL MODULE: ./src/components/_shared/media/media.tsx + 3 modules
var media = __webpack_require__(38925);
// EXTERNAL MODULE: ./src/components/_shared/teaser-card-components/teaser-card-profile-picture/teaser-card-profile-picture.module.scss
var teaser_card_profile_picture_module = __webpack_require__(93577);
var teaser_card_profile_picture_module_default = /*#__PURE__*/__webpack_require__.n(teaser_card_profile_picture_module);
;// CONCATENATED MODULE: ./src/components/_shared/teaser-card-components/teaser-card-profile-picture/teaser-card-profile-picture.tsx





var TeaserCardProfilePicture = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(media/* Media */.pU, {
        className: (teaser_card_profile_picture_module_default())["profile-picture"],
        alt: "profile-picture",
        isProfile: true,
        initialLoad: props.initialLoad,
        src: buildProfilePictureUrl(props.profilePictureId),
        classNameWrapper: (teaser_card_profile_picture_module_default())["profile-picture-wrapper"],
        squared: true
    });
};
/* harmony default export */ var teaser_card_profile_picture = (TeaserCardProfilePicture);


/***/ }),

/***/ 70010:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","basic-card-wrapper":"basic-card_basic-card-wrapper__K0IFR","basic-card-content-container":"basic-card_basic-card-content-container__Dtk7Z","selected":"basic-card_selected__gOaE7","inverted":"basic-card_inverted__7yBla","teaser-card-category":"basic-card_teaser-card-category__4YpTa","teaser-card-category-mobile":"basic-card_teaser-card-category-mobile__Ytg7d","teaser-card-images":"basic-card_teaser-card-images__Us16R","basic-card-small":"basic-card_basic-card-small__vHT0U","creatoken-card":"basic-card_creatoken-card__dPLae","basic-card-horizontal-small":"basic-card_basic-card-horizontal-small__MOV8e","teaser-card-text":"basic-card_teaser-card-text__Brcax","teaser-card-text-line":"basic-card_teaser-card-text-line__r_wyM","basic-card-horizontal-small-text":"basic-card_basic-card-horizontal-small-text__REJ42","basic-card-horizontal-normal-text":"basic-card_basic-card-horizontal-normal-text__jQbgK","basic-card-horizontal-small-images":"basic-card_basic-card-horizontal-small-images__ciaFX","basic-card-horizontal-normal-images":"basic-card_basic-card-horizontal-normal-images__ZYmXA","podcast-teaser":"basic-card_podcast-teaser__0s7i5","podcast-category-wrapper":"basic-card_podcast-category-wrapper__JCZG0","purchase-card-normal":"basic-card_purchase-card-normal__5zNRx","author":"basic-card_author__EGauI","basic-card-wrapper-normal":"basic-card_basic-card-wrapper-normal__rNkDm","basic-card-horizontal-normal":"basic-card_basic-card-horizontal-normal___BjXd","clickable":"basic-card_clickable__Fv43d","disabled":"basic-card_disabled__ysuYd"};

/***/ }),

/***/ 31050:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","category-image-wrapper":"teaser-card-category_category-image-wrapper__dz2Bx","category-image-wrapper-art":"teaser-card-category_category-image-wrapper-art__Kypn1","category-image-wrapper-audio":"teaser-card-category_category-image-wrapper-audio__dXqDz","category-image-wrapper-ebook":"teaser-card-category_category-image-wrapper-ebook__6BZGu","category-image-wrapper-book":"teaser-card-category_category-image-wrapper-book__T0z9g","category-image-wrapper-kinked":"teaser-card-category_category-image-wrapper-kinked__bsSwI","category-image-wrapper-arrow":"teaser-card-category_category-image-wrapper-arrow__eHM_H"};

/***/ }),

/***/ 61979:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","footer-wrapper":"teaser-card-footer_footer-wrapper__DcJs5","additional-info-wrapper":"teaser-card-footer_additional-info-wrapper__qU_sD","sales-future-date":"teaser-card-footer_sales-future-date__uDMke","inverted":"teaser-card-footer_inverted__QJXFG","buy-wrapper":"teaser-card-footer_buy-wrapper__DCIy6","price-wrapper":"teaser-card-footer_price-wrapper__lHHYX","primary-price":"teaser-card-footer_primary-price__xiRbw","secondary-price":"teaser-card-footer_secondary-price__J_zYZ","price":"teaser-card-footer_price__YJXd3","buy-wrapper-auction":"teaser-card-footer_buy-wrapper-auction__GLMM_","ethPrice":"teaser-card-footer_ethPrice__PWJ_f","more-info-wrapper":"teaser-card-footer_more-info-wrapper__hzE9S","turn-around-wrapper":"teaser-card-footer_turn-around-wrapper__J1UBY","icon":"teaser-card-footer_icon__Sm1_a","info-and-buy-button-wrapper":"teaser-card-footer_info-and-buy-button-wrapper__WxxVy","details-and-auction-button-wrapper":"teaser-card-footer_details-and-auction-button-wrapper__9jwr8","date-wrapper":"teaser-card-footer_date-wrapper__rF5rK","basic-card-horizontal-small":"teaser-card-footer_basic-card-horizontal-small__huyQo","podcast-teaser":"teaser-card-footer_podcast-teaser__mlTUW","purchase-card-normal":"teaser-card-footer_purchase-card-normal__Il3t3"};

/***/ }),

/***/ 90234:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","basic-card-image-wrapper":"teaser-card-images_basic-card-image-wrapper__8BHo6","image":"teaser-card-images_image__0WxJt","profile-picture-wrapper":"teaser-card-images_profile-picture-wrapper__2Vw4f","podcast-duration":"teaser-card-images_podcast-duration__m0Fda","duration-button":"teaser-card-images_duration-button__ZJ4Kx","label-wrapper":"teaser-card-images_label-wrapper__FBssi","label":"teaser-card-images_label__GIsoy","purchase-card-normal":"teaser-card-images_purchase-card-normal___C5_A","podcast-teaser":"teaser-card-images_podcast-teaser__5x9Zs","basic-card-image-wrapper-widescreen":"teaser-card-images_basic-card-image-wrapper-widescreen__0FLU_","basic-card-image-wrapper-fullscreen":"teaser-card-images_basic-card-image-wrapper-fullscreen__RI51c"};

/***/ }),

/***/ 93577:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary_accent":"#21547f","primary_lightAccent":"#3280bf","primary_dark":"#426dfd","primary_middleDark":"#42aaff","primary_middleLight":"#93bbd0","primary_light":"#dae3e5","greys_dark":"#000","greys_darkAccent":"#292929","greys_darkLight":"#333","greys_middleDark":"gray","greys_middle":"#858585","greys_middleLight":"#b3b3b3","greys_lightDark":"#f2f2f2","greys_lightAccent":"#eee","greys_light":"#fff","categoryColors_audio":"#fa4166","categoryColors_art":"#a2d902","categoryColors_eBook":"#1ce0c6","categoryColors_book":"#1ce0d6","signalColors_error":"red","signalColors_warning":"#f90","signalColors_success":"#11f49d","opacity_dark50":"rgba(0,0,0,.5)","opacity_dark10":"rgba(0,0,0,.1)","other_genreGreen":"#b5b124","desktop":"1366px","desktopSmall":"1024px","mobile":"576px","profile-picture-wrapper":"teaser-card-profile-picture_profile-picture-wrapper__DSotm","profile-picture":"teaser-card-profile-picture_profile-picture__QOpxe"};

/***/ })

}]);